
//Import React Hooks
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom' //useParams to get the id transmitted in the url


// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Week from '../../components/week/Week.jsx'
import EleveList from '../../components/elevelist/EleveList.jsx'
import CalendarCart from '../../components/calendarcart/CalendarCart.jsx'
import Background from '../../components/background/Background.jsx'
import Comments from '../../components/comments/Comments.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { elevesSlice } from "../../store/elevesSlice.js";
import { formulesSlice } from "../../store/formulesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";

// API fetch
import axios from "axios";
import { baseURL, appURL } from '../../config/api-config.js';

// config
import { listFidelite, listNiveau } from '../../config/niveau-fidelite-config.js';

//Utils 
import { creneauxSorter2, creneauxSorter3 } from '../../utils/creneaux_sorter.js';
import setNumResa from '../../utils/set_num_resa.js';
import convertHoraire from '../../utils/convert_horaire.js';


//// - we get infos from the DB to show editables infos for a Resa ////
function MatchResa() { // full page as component imported in router

    const { idResa, idClient } = useParams(); //id of the selected resa, in url (as string)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [allInfos, setAllInfos] = useState([]);
    const [dejaMatched, setDejaMatched] = useState();
    const [matchWally, setMatchWally] = useState();
    const [displayInfos, setDisplayInfos] = useState();
    const [htmlMail, setHtmlMail] = useState("");
    const [htmlMailWally, setHtmlMailWally] = useState("");
    let [clientMail, setClientMail] = useState();
    let [clientName, setClientName] = useState();
    let [resaNum, setResaNum] = useState();
    let [nbModifs, setNbModifs] = useState();
    let [sent, setSent] = useState(false);
    let [sentYann, setSentYann] = useState(false);
    let [fail, setFail] = useState(false);

    //// -- At first render :
    useEffect(() => {
        async function patchResa() { //we add this inner function to manage asynchrone
            let resaInfos = await matchResa(); // get resa infos from DB ...
            if (resaInfos.Client.id_client != parseInt(idClient)) {
                navigate("../error")
            }

            setAllInfos(resaInfos);

        } //end of async function
        patchResa(); //call the inner asnchrone function

        async function getMatch() { //we add this inner function to manage asynchrone
            let resaInfos = await getResaInfos(); // get resa infos from DB ...
            setDejaMatched(resaInfos.match);

        } //end of async function
        getMatch(); //call the inner asnchrone function
    }, [idResa])
    //// --

    //// -- At allInfos init :
    useEffect(() => {
        allInfos.Client && setMatchWally(numIsPair(allInfos.nb_modifs));
        console.log(allInfos)
    }, [allInfos])
    //// --

    //// -- At allInfos init :
    useEffect(() => {
        allInfos.Client && handleResa(allInfos);
    }, [matchWally])
    //// --

    //// -- At allInfos init :
    useEffect(() => {
        //console.log(htmlMail);
        //console.log("mail client");

        /* console.log(dejaMatched)
        if (dejaMatched === true) {
            console.log("match deja fait");
            //return;
        }//// block useEffect at every render */

        if (htmlMail === "" || sent === true) { return; }//// block useEffect at every render


        //let objet = matchWally === true ? "Match! Votre demande de réservation a été validée par Wally Glisse" : "votre confirmation de réservation a bien été prise en compte";

        let mailSubject = "";

        if (matchWally === true) {
            mailSubject = `Match! Votre demande de réservation a été validée par Wally Glisse. Résa. ${resaNum} - (${nbModifs + 1})`;
        }
        else {
            mailSubject = `votre confirmation de réservation a bien été prise en compte. Résa. ${resaNum} - (${nbModifs + 1}) `;
        }

        let body = {
            //to: "manuel.vivion@gmail.com", //// -- client mail
            to: clientMail, //// -- client mail
            subject: mailSubject,
            html: htmlMail
        };

        setSent(true);

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {
                if (response.status === 201 || response.status === 200) { //isnertion OK
                    setFail(false); //to not trigger alert message
                    //console.log(response.data)

                }
                else { //mail problème
                    setFail(true); //to trigger alert message
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })

    }, [htmlMail])
    //// --

    //// -- At allInfos init :
    useEffect(() => {
        //console.log(htmlMailWally);

        if (htmlMailWally === "" || sentYann === true) { return; }//// block useEffect at every render

        //let objet = matchWally === true ? "[Nestor Surf] - réservation confirmée" : "[Nestor Surf] - Match de réservation";

        let mailSubject = "";

        if (matchWally === true) {
            mailSubject = `( ${clientName} : Match ) -- réservation confirmée. Résa. ${resaNum} - (${nbModifs + 1})`;
        }
        else {
            mailSubject = `( ${clientName} : Match ) -- Le client a confirmé. Résa. ${resaNum} - (${nbModifs + 1}) `;
        }

        /* console.log(dejaMatched)
        if (dejaMatched === true) {
            console.log("match deja fait");
            //return;
        }//// block useEffect at every render */



        let body = {
            //to: "manuel.vivion@gmail.com", //// -- wallyglisse@gmail.com
            to: "wallyglisse@gmail.com", //// -- wallyglisse@gmail.com
            subject: mailSubject,
            html: htmlMailWally,
            client: clientName,
        };

        setSentYann(true);

        axios.post(`${baseURL}/mailing/mail-reception-demande`, body)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    setFail(false); //to not trigger alert message
                    //console.log(response.data)

                }
                else { //mail problème
                    setFail(true); //to trigger alert message
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })
    }, [htmlMailWally])
    //// --



    async function matchResa() { // Get Resa Infos from DB (request with joins...)

        try {
            const response = await axios({
                method: 'PUT',
                url: baseURL + `/resa/match/${idResa}`,

            });
            //console.log(response);
            const infos = response.data.data[0];
            return infos;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async function getResaInfos() { // Get Resa Infos from DB (request with joins...)

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/${idResa}`,

            });
            //console.log(response);
            const infos = response.data;
            return infos;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function handleResa(allInfos) {
        matchWally && console.log(matchWally);
        console.log(allInfos);
        let sortedInfos = sortElevesCreneaux(allInfos.CreneauEleves);
        setDisplayInfos(sortedInfos);

        updateElevesNbCours(sortedInfos.eleves, sortedInfos.creneaux);

        setHtmlMail(prepaMail(allInfos, sortedInfos, matchWally).htmlClient);
        setHtmlMailWally(prepaMail(allInfos, sortedInfos, matchWally).htmlWally);
        setClientMail(prepaMail(allInfos, sortedInfos, matchWally).dest);
        setResaNum(prepaMail(allInfos, sortedInfos, matchWally).ref);
        setClientName(prepaMail(allInfos, sortedInfos, matchWally).name);
        setNbModifs(prepaMail(allInfos, sortedInfos, matchWally).nb_modifs);



    }

    function numIsPair(n) {
        return ((n % 2) > 0) ? false : true;
    }

    function sortElevesCreneaux(creneaux) {

        let allEleves = [];
        let allCreneaux = [];
        let dateList = [];

        creneaux.map((creneauEleve) => { // for every line in CreneauEleve Table...
            //// -- We want a list of eleves

            // if eleve not in the list already...
            if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
                allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                    id: creneauEleve.Eleve.id_eleve,
                    prenom: creneauEleve.Eleve.prenom,
                    age: creneauEleve.Eleve.age,
                    nb_cours: creneauEleve.Eleve.nb_cours,
                });
                allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
            }

            if (allCreneaux.filter((creneau) => creneau.id === creneauEleve.Creneau.id_creneau).length === 0) {
                allCreneaux.push({
                    eleves: [{ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom }],
                    date: creneauEleve.Creneau.date,
                    horaire: creneauEleve.Creneau.horaire,
                    id: creneauEleve.Creneau.id_creneau
                });
                allCreneaux.sort((d1, d2) => creneauxSorter2(d1, d2));
            }
            else {
                allCreneaux.find((c) => c.id === creneauEleve.Creneau.id_creneau).eleves.push({ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom });
            }


            dateList.push(creneauEleve.Creneau.date);


        });// end of map

        let dateSet = new Set(dateList);
        let newDatesList = Array.from(dateSet); //we need this list of date to display a calendar with only days with creneaux
        newDatesList.sort((d1, d2) => creneauxSorter3(d1, d2));

        return ({ eleves: allEleves, creneaux: allCreneaux, dateList: newDatesList })
    }//end of function


    function updateElevesNbCours(eleves, creneaux) {
        let nbSuccess = 0;
        let problemes = [];

        eleves.map((eleve) => {
            let oldNbCours = eleve.nb_cours;
            let newNbCours = creneaux.filter((creneau) => creneau.eleves.find((e) => eleve.id === e.id) ? true : false/* eleve.id === creneau.eleve_id */).length
            console.log(eleve.id, parseInt(oldNbCours + newNbCours))

            axios.put(`${baseURL}/eleve/${eleve.id}`, { //...we add him in the db
                nb_cours: parseInt(oldNbCours + newNbCours)
            })
                .then((response) => {
                    if (response.status === 200) { //modif ok : code 200...
                        nbSuccess++;
                    }
                    else {
                        problemes.push(response.status);
                    }
                })
                .catch(error => {
                    problemes.push(error);
                })
        })//end of map

        if (nbSuccess === eleves.length) { //every request went good
            console.log("modifs nbcours ok");
        }
        else {
            console.log(problemes.length + " erreurs modifs nbcours");
        }
    } // end of function


    return (
        <div className="bg-relative">
            <Background ind={2} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">

                    <WallyBanner />

                    <div className="match">
                        <div className="match-intro">
                            <h1>It's a match!</h1>
                            <p>{`La confirmation de la réservation ${allInfos.Client && setNumResa({ total: allInfos.total, created: allInfos.created, id_resa: allInfos.id_resa })} pour ${allInfos.Client && allInfos.Client.prenom} ${allInfos.Client && allInfos.Client.nom} a bien été prise en compte`}</p>
                        </div>

                        <div className="match-jours">
                            {displayInfos && displayInfos.dateList.map((date) => (
                                <div className="match-jours-bloc" key={date}>
                                    <h3 className="match-jours-bloc-date">{dayjs(date).format("DD/MM/YYYY")}</h3>
                                    {displayInfos.creneaux.filter((c) => c.date === date).map((creneau) => (
                                        <div className="match-jours-bloc-creneau" key={creneau.id}>
                                            <p className="match-jours-bloc-creneau-horaire">{convertHoraire(creneau.horaire, "horaire")}</p>
                                            <ul className="match-jours-bloc-creneau-eleves">
                                                {creneau.eleves.map((e, index) => (
                                                    <li key={index}>{e.prenom}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>

                        <div className="match-bottom">
                            <div className="match-bottom-total">
                                <p>Montant du panier</p>
                                {allInfos.coupon > 0 ?
                                    <p>{` (réduction de ${allInfos.coupon}% appliquée)`}</p>
                                    : null}
                                <h5>{Math.round((100 - allInfos.coupon) / 100 * allInfos.total) + ",00 €"}</h5>

                            </div>

                            {matchWally === false ?
                                <div>
                                    <p>Concernant le paiement de votre réservation, vous pourrez régler sur place, lors de votre session. Moyens de paiement sur place : espèces, chèques ou chèques vacances ANCV.</p>
                                    <p>MAIS, si vous le souhaitez, pour anticiper, vous pouvez déjà régler votre réservation (comme ça : rien à faire sur place)</p>
                                    <a href={appURL + "/paiement/" + allInfos.id_resa + "/" + allInfos.Client.id_client}>
                                        <div className="match-bottom-bouton">Payez votre réservation en ligne</div>
                                    </a>
                                </div>
                                : null}

                            {allInfos.ResaCommentaires && allInfos.ResaCommentaires.length > 0 ?
                                <div className="match-bottom-commentaire">
                                    <p>Commentaire:</p>
                                    <h5>{allInfos.ResaCommentaires && allInfos.ResaCommentaires[allInfos.ResaCommentaires.length - 1].commentaire}</h5>
                                </div>
                                : null}

                        </div>
                    </div>


                </div>
            </main>
        </div>
    );
}

export default MatchResa;

function prepaMail(allInfos, sortedInfos, matchWally) {

    let htmlBodyYann = "";
    let htmlBody = `<html lang='fr'>

    <head>
        <meta charset='UTF-8'>
        <style>
        body {
            background-color: white;
            font-family: Arial, Helvetica, sans-serif;
            text-align: justify;
            margin: 0;
        }

        p {
            font-size: 14px;
        }

        section {
            background-color: #eee;
            width: 90%;
            margin: 16px auto;
            padding: 16px;
            border-bottom: 1px solid #E91E63;
        }

        h3 {
            text-align: center;
            text-decoration: underline;
        }

        .match {
            background-color: rgba(255, 255, 255, 0.8);
            border-top: 4px solid #362782;
            margin-bottom: 16px;
            position: relative;
            padding: 16px 8px;
        }

        .match-intro {
            text-align: center;

        }

        .match-intro h1 {
            display: block;
            width: 90%;
            margin: auto;
            background-color: #E91E63;
            color: white;
            font-size: 24px;
            padding: 16px;
        }

        .coordonnees .client,
        .coordonnees .wally {
            width: 70%;
            margin: auto;
            background-color: #dedede;
            padding: 8px;
        }

        .coordonnees p {
            margin: 8px;
        }

        .coordonnees .p1 {
            font-size: 16px;
            font-weight: bold;
        }

        .match-jours-bloc {
            width: 80%;
            margin: auto;
        }

        .match-jours-bloc-date {
            display: block;
            text-align: center;
            margin: auto;
            background-color: #34B0EE;
            color: white;
            font-weight: 300;
            padding: 8px;
            text-decoration: none;
        }



        .match-jours-bloc-creneau-horaire {
            display: block;
            text-align: center;
            margin: auto;
            background-color: #E0D5B5;
            color: #362782;
            border-bottom: 1px solid #362782;
            padding: 8px;
        }
        .total {
            display: flex;
            align-items: center;
        }

        .total h5 {
            font-size: 18px;
        }

        .total h5,
        p {
            margin: 4px;
        }
        .backpack-list {
            border-top: 1px solid #E91E63;
            margin: 8px;
            padding: 16px;
        }

        .backpack-list-item {
            display: flex;
            align-items: center;
            padding: 8px;
        }

        .backpack-list-item img {
            width: 48px;
            margin-right: 16px;
            background-color: #666;
            padding: 4px;
            border-radius: 50%;
        }

        .backpack-list-item p {
            font-size: 16px;
            text-transform: uppercase;
        }

        .bouton-match,
        .bouton-modif {
            display: block;
            padding: 16px 32px;
            background-color: #E91E63;
            border-radius: 5px;
            margin: 4px 8px;
            color: white;
            cursor: pointer;
            font-size: large;
            width: 280px;
            margin: auto;
            margin-bottom: 16px;
            text-align: center;
        }

    </style>
    </head>`;

    htmlBody += `
  <body>
  <section class="intro">
      <div class="match-intro">
          <h1>It's a match!</h1>`;

    htmlBodyYann += htmlBody;

    if (matchWally === true) { //match sent from wally
        htmlBody += `<h3>Votre réservation est validée !</h3>
            <p>Bonne nouvelle ${allInfos.Client.prenom} ${allInfos.Client.nom},<br>Votre demande de réservation a bien été validée par l'équipe de Wally
                Glisse :-)</p>`;
        htmlBodyYann += `<h3>la réservation pour le client ${allInfos.Client.prenom} ${allInfos.Client.nom} a bien été validée  !</h3>
                <p>num. de réservation : ${setNumResa({ total: allInfos.total, created: allInfos.created, id_resa: allInfos.id_resa })}</p>`;
    }
    else {//match sent from client
        htmlBody += `<h3>Votre confirmation a bien été enregistrée!</h3>`;
        htmlBodyYann += `<h3>Le client ${allInfos.Client.prenom} ${allInfos.Client.nom} a validé sa réservation  !</h3>
        <p>num. de réservation : ${setNumResa({ total: allInfos.total, created: allInfos.created, id_resa: allInfos.id_resa })}</p>`;
    }

    htmlBody += ` 
    </div>
    </section>

    <section class="sessions">
    <h3>Rappel de vos sessions : </h3>
    <p>Toute l'équipe de Wally Glisse vous attend donc plage du Lion, pour les sessions suivantes : </p>
    <div class="match-jours">`;

    htmlBodyYann += ` 
    </div>
    </section>
    <section class="sessions">
    <h3>Rappel des sessions : </h3>
    <div class="match-jours">`;

    let loopBody = "";

    sortedInfos && sortedInfos.dateList.map((date) => {

        loopBody += `<div class="match-jours-bloc">
            <h3 class="match-jours-bloc-date">${dayjs(date).format("DD/MM/YYYY")}</h3>`;

        sortedInfos.creneaux.filter((c) => c.date === date).map((creneau) => {
            loopBody += `<div class="match-jours-bloc-creneau">
                    <p class="match-jours-bloc-creneau-horaire">${convertHoraire(creneau.horaire, "horaire")}</p>
                    <ul class="match-jours-bloc-creneau-eleves">`
            creneau.eleves.map((e) => {
                loopBody += `<li >${e.prenom}</li>`;
            })
            loopBody += `</ul>
                </div>`
        })
        loopBody += `</div>`;
    })

    htmlBody += loopBody;
    htmlBodyYann += loopBody;

    htmlBody += ` </div> 

    </section>

    <section class="total">
    <p>Montant du panier ${allInfos.coupon > 0 ? "(réduction de " + allInfos.coupon + "% appliquée)" : ""} :</p> 
    <h5>${Math.round((100 - allInfos.coupon) / 100 * allInfos.total)},00 €</h5>
    </section>

    <section class="boutons-liens">
        <p>Concernant le paiement de votre réservation, vous pourrez régler sur place, lors de votre session. Moyens de paiement sur place : espèces, chèques ou chèques vacances ANCV.</p>
        <p>MAIS, si vous le souhaitez, pour anticiper, vous pouvez déjà régler votre réservation (comme ça : rien à faire sur place)</p>
        <a href="${appURL + "/paiement/" + allInfos.id_resa + "/" + allInfos.Client.id_client}" target="_blank">
            <p class="bouton-match">Payer votre réservation en ligne</p>
        </a>
        
    </section>

    <section class="commentaire">
    <p>${allInfos.ResaCommentaires.length > 0 ? "Commentaire:" : ""}</p>
    <h5>${allInfos.ResaCommentaires.length > 0 ? allInfos.ResaCommentaires[allInfos.ResaCommentaires.length - 1].commentaire : ""}</h5>

    </section>

    <section class="backpack">
        <h3>Backpack</h3>
        <p>Pensez bien à préparer tout ça pour votre prochaine session :</p>
        <div class="backpack-list">
            <div class="backpack-list-item">
                <img src="https://wallyglisse.com/images/picto_bp_creme.png" alt="creme solaire">
                <p>Crème Solaire</p>
            </div>
            <div class="backpack-list-item">
                <img src="https://wallyglisse.com/images/picto_bp_towel.png" alt="serviette de bain">
                <p>Serviette de plage</p>
            </div>
            <div class="backpack-list-item">
                <img src="https://wallyglisse.com/images/picto_bp_smile.png" alt="sourire, bonne humeur">
                <p>Sourire et bonne humeur</p>
            </div>
            <div class="backpack-list-item">
                <img src="https://wallyglisse.com/images/picto_bp_time.png" alt="en avance">
                <p>Arriver 10 minutes en avance pour s'équiper</p>
            </div>

        </div>
    </section>

    <section class="coordonnees">
        <h3>Nos coordonnées : </h3>
        <div class="coordonnees wally">
            <p class="coordonnees p1">Wally Glisse</p>
            <p>wallyglisse@gmail.com</p>
            <p>tel : +33 (0)6 19 07 05 53</p>
        </div>

    </section>
</body>

</html>`;

    htmlBodyYann += ` </div> 
    </section>

    <section class="total">
    <p>Montant du panier ${allInfos.coupon > 0 ? "(réduction de " + allInfos.coupon + "% appliquée)" : ""} :</p> 
    <h5>${Math.round((100 - allInfos.coupon) / 100 * allInfos.total)},00 €</h5>
    </section>

    <section class="commentaire">
    <p>${allInfos.ResaCommentaires.length > 0 ? "Commentaire:" : ""}</p>
    <h5>${allInfos.ResaCommentaires.length > 0 ? allInfos.ResaCommentaires[allInfos.ResaCommentaires.length - 1].commentaire : ""}</h5>
    </section>

    <section class="coordonnees">
        <h3>coordonnées client: </h3>
        <div class="coordonnees wally">
            <p class="coordonnees p1">${allInfos.Client.prenom} ${allInfos.Client.nom}</p>
            <p>mail :${allInfos.Client.email}</p>
            <p>tel : ${allInfos.Client.tel}</p>
            <p>tel2 : ${allInfos.Client.tel2}</p>
        </div>

    </section>
</body>

</html>`;


    return ({ htmlClient: htmlBody, htmlWally: htmlBodyYann, dest: allInfos.Client.email, ref: setNumResa(allInfos), name: allInfos.Client.nom, nb_modifs: allInfos.nb_modifs });

}